import React from 'react';
import { Route } from 'react-router-dom';

import Login from 'app/modules/login/login';
import Logout from 'app/modules/login/logout';
import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';
import PageNotFound from 'app/shared/error/page-not-found';
import ClientHome from 'app/client_zone/home/client-home';
import ContractPage from 'app/client_zone/contract/contract-page';
import NewRequestPage from 'app/client_zone/request/new-request-page';
import ExistingRequestsPage from 'app/client_zone/request/existing-requests-page';
import ClientMessagePage from 'app/client_zone/message/client-message-page';
import ContractDetailPage from 'app/client_zone/contract/contract-detail-page';
import AccountPage from 'app/client_zone/account/account-page';
import ConditionPage from 'app/client_zone/texts/condition-page';
import PersonalDataPage from 'app/client_zone/texts/personal-data-page';
import ClientDetailNew from 'app/client_zone/home/client-detail-new';
import ChangePasswordPage from 'app/client_zone/account/change-password-page';

const loading = <div>loading ...</div>;

// const Account = Loadable({
//   loader: () => import(/* webpackChunkName: "account" */ 'app/modules/account'),
//   loading: () => loading,
// });
//
// const Admin = Loadable({
//   loader: () => import(/* webpackChunkName: "administration" */ 'app/modules/administration'),
//   loading: () => loading,
// });
const ClientAppRoutes = () => {
  // const pageLocation = useLocation();
  // React.useEffect(() => {
  //   sendActivity(pageLocation.pathname);
  // }, [pageLocation]);

  return (
    <div className="view-routes">
      <ErrorBoundaryRoutes>
        <Route index element={<ClientHome />} />

        <Route path="login" element={<Login />} />
        <Route path="logout" element={<Logout />} />

        <Route path="/news/:id" element={<ClientDetailNew />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
        <Route path="/contracts" element={<ContractPage />} />
        <Route path="/contracts/:id" element={<ContractDetailPage />} />
        <Route path="/requests/new/:id?" element={<NewRequestPage />} />
        <Route path="/requests" element={<ExistingRequestsPage />} />
        <Route path="/messages" element={<ClientMessagePage />} />

        <Route path="/account" element={<AccountPage />} />
        <Route path="/conditions" element={<ConditionPage />} />
        <Route path="/personal-data" element={<PersonalDataPage />} />

        <Route path="*" element={<PageNotFound />} />
      </ErrorBoundaryRoutes>
    </div>
  );
};

export default ClientAppRoutes;
